import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ChangeModule } from '@updater/angular-common';
import { VerifyConfig } from './verify.config';
import { VerifyComponent } from './verify.component';
import { VerifyCreditCardModule } from './credit-card';
import { VerifyPhoneModule } from './phone';
import '@updater-components/radio-group';
import '../steps/forward-mail/new-design/progress-header';

export const VerifyModule = angular
  .module('app.verify', [
    uiRouter,
    VerifyCreditCardModule.name,
    VerifyPhoneModule.name,
    ChangeModule.name,
  ])
  .config(VerifyConfig)
  .component('updVerify', VerifyComponent);
